/**
 * tokens.ts — JS/Canvas Token Mirror
 *
 * MIRROR FILE: Values must be kept in sync with src/styles/tokens.css
 *
 * Usage:
 *   CSS context  → use var(--color-*) from tokens.css
 *   JS/Canvas    → import { DRAW_COLORS } from '@/styles/tokens'
 *
 * SYNC RULE: Any value change requires updating BOTH files simultaneously.
 * TODO: Add CI lint check to diff token values between tokens.css and tokens.ts
 *       and fail the build on mismatch. This comment is the contract until then.
 */

export const DRAW_COLORS = {
  bullish: '#16B85A',  // --color-trend-bullish
  bearish: '#F04545',  // --color-trend-bearish
  fib:     '#F5A623',  // --color-fib-level
  measure: '#5DC8E8',  // --color-tool-measure
  pattern: '#9D7FEA',  // --color-tool-pattern
  alert:   '#F07848',  // --color-tool-alert
  info:    '#0EC4B4',  // --color-tool-info
  default: '#E4EAF4',  // --color-tool-default
} as const;

export type DrawColorKey = keyof typeof DRAW_COLORS;
